import React from 'react';
import ReactDOM from 'react-dom/client';

import { silenceConsole } from 'shared/lib/silenceConsole';
import 'shared/config/i18n';
import App from './app';

silenceConsole();

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
